var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88674 26.1673H20.1157C20.7179 26.2266 21.3258 26.1564 21.8985 25.9614C22.4713 25.7665 22.9958 25.4512 23.4367 25.0368C23.8776 24.6224 24.2247 24.1185 24.4548 23.5589C24.6849 22.9993 24.7926 22.397 24.7707 21.7923L25.3774 12.1557C25.4152 11.5579 25.33 10.9588 25.1271 10.3953C24.9241 9.83183 24.6077 9.31599 24.1974 8.87967C23.7871 8.44336 23.2917 8.09586 22.7417 7.85866C22.1918 7.62146 21.599 7.49962 21.0001 7.50065C20.6502 7.49846 20.3076 7.40054 20.0094 7.2175C19.7112 7.03447 19.4688 6.7733 19.3084 6.46232L18.4684 4.77065C18.1502 4.21262 17.6974 3.74308 17.1513 3.40482C16.6052 3.06656 15.9831 2.87032 15.3417 2.83398H12.6701C12.0267 2.86841 11.4022 3.06375 10.8539 3.40211C10.3056 3.74047 9.85102 4.21102 9.53174 4.77065L8.69174 6.46232C8.53139 6.7733 8.28897 7.03447 7.99077 7.2175C7.69257 7.40054 7.34996 7.49846 7.00007 7.50065C6.40135 7.49993 5.80884 7.62202 5.25917 7.85936C4.70949 8.09669 4.21433 8.44424 3.8043 8.88052C3.39426 9.3168 3.07806 9.83254 2.87523 10.3959C2.6724 10.9592 2.58726 11.5581 2.62507 12.1557L3.23174 21.7923C3.20889 22.3972 3.31596 23 3.54573 23.5601C3.7755 24.1201 4.12263 24.6244 4.56374 25.039C5.00485 25.4536 5.5297 25.7688 6.10291 25.9635C6.67612 26.1581 7.28439 26.2276 7.88674 26.1673Z",
    stroke: "#1B1E28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.83398H15.75",
    stroke: "#1B1E28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.4994C14.75 21.4994 15.483 21.277 16.1066 20.8603C16.7301 20.4437 17.2161 19.8515 17.5031 19.1587C17.7901 18.4659 17.8652 17.7035 17.7189 16.968C17.5725 16.2325 17.2114 15.5568 16.6812 15.0266C16.1509 14.4963 15.4753 14.1352 14.7398 13.9889C14.0042 13.8426 13.2419 13.9177 12.549 14.2046C11.8562 14.4916 11.264 14.9776 10.8474 15.6011C10.4308 16.2247 10.2084 16.9578 10.2084 17.7077C10.2102 18.7127 10.6103 19.6761 11.321 20.3868C12.0316 21.0974 12.995 21.4975 14 21.4994Z",
    stroke: "#1B1E28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.eed1c323f16ebd0f2f337b95a7681c41.svg";
export { ForwardRef as ReactComponent };